import React from "react";
import {
  Tab,
} from "semantic-ui-react";
import Consumptions from "./Consumptions";
import ConsumptionUsages from "./ConsumptionUsages";
import { dispatch } from "@rematch/core";


export default class ConsumptionDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
  }

  componentDidMount() {
    if(this.props.match && this.props.match.params && this.props.match.params.accountId) {
      dispatch.account.selectAccount({ accountId: this.props.match.params.accountId });
      dispatch.app.setAccountSubscriptionDetails(this.props.match.params.accountId)
    }
  }

  render() {
    const panes = [
  {
    menuItem: "Current Usages",
    render: () => (
      <Tab.Pane>
        <ConsumptionUsages {...this.props}/>
      </Tab.Pane>
    ),
  },

  {
    menuItem: "Consumption Details",
    render: () => (
      <Tab.Pane>
        <Consumptions {...this.props}/>
      </Tab.Pane>
    ),
  },
];

    return (
      <div>
          <Tab
            panes={panes}
            activeIndex={this.state.activeIndex}
            onTabChange={(e, { activeIndex }) =>
                this.setState({ activeIndex })
            }
            />
        </div>
    );
  }
}
